import React, { useEffect } from "react";
import Stack from "@mui/material/Stack/Stack";
import { ProductCard } from "./ProductCard";
import { useSelector } from "react-redux";
import { storeActions, StoreState } from "../../store";
import { ReceiptCheckItem } from "../../../../../../domain/models/receipt-check";
import { Total } from "../../../Components/Total";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Typography } from "@mui/material";

export const StoreMain: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const items = useSelector<StoreState, ReceiptCheckItem[]>(
    (state) => state.items
  );

  return (
    <>
      <DrawerAppBar
        title="Guardar Mercadoria"
        onBack={() => {
          navigate("/mobile/tasks");
        }}
      />
      <Total
        text="Total de Mercadorias a Guardar"
        number={items.length.toString()}
      />
      {items.length === 0 && (
        <Typography sx={{ m: "20px" }}>
          Não há itens a serem guardados
        </Typography>
      )}
      <Stack sx={{ m: "20px" }} spacing={4}>
        {items.map((item) => {
          return (
            <ProductCard
              onClick={() => {
                dispatch(storeActions.setCurrentItem({ item }));
                navigate("/mobile/store/collector");
              }}
              item={item}
              key={item.id}
            />
          );
        })}
      </Stack>
    </>
  );
};
